import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone.js';
import utc from 'dayjs/plugin/utc.js';

dayjs.extend(utc);
dayjs.extend(timezone);

const TIMEZONE = 'UTC';
const SHORT_TIMEZONE = ' UTC';

export function formatDate(
  dateString,
  { emptyPlaceholder = '-', format = 'DD MMM YYYY, HH:mm:ss', timezone: longTimezone = TIMEZONE, shortTimezone = SHORT_TIMEZONE } = {}
) {
  if (!dateString) {
    return emptyPlaceholder;
  }

  let date;
  if (/([Zz]|[+-]\d{2}:?\d{2})$/.test(dateString)) {
    // ISO string with timezone info
    date = dayjs(dateString);
  } else {
    // No timezone info, treat as UTC
    date = dayjs.utc(dateString);
  }
  // Convert to Kyiv time
  const kyivDate = date.tz(longTimezone);
  return kyivDate.format(format) + shortTimezone;
}

export function formatDateTime(value) {
  if (!value) return '';
  return new Date(value).toISOString().slice(0, 19).replace('T', ' ') + ' UTC';
}

export function formatBytes(bytes) {
  if (bytes === 0 || bytes === '0') {
    return '0 Bytes';
  }

  if (!bytes) {
    return '-';
  }

  // Ensure bytes is a number, handle string and bigint
  let numBytes;
  if (typeof bytes === 'bigint') {
    numBytes = Number(bytes);
  } else if (typeof bytes === 'string') {
    // Try to parse as BigInt first, fallback to Number
    try {
      numBytes = Number(BigInt(bytes));
    } catch {
      numBytes = Number(bytes);
    }
  } else {
    numBytes = bytes;
  }

  if (Number.isNaN(numBytes) || numBytes < 0) {
    return '-';
  }

  const sizes = [ 'Bytes', 'KB', 'MB', 'GB', 'TB' ];
  const i = Math.floor(Math.log(numBytes) / Math.log(1024));
  const value = (numBytes / 1024 ** i).toFixed(2);

  return `${value} ${sizes[i]}`;
}
